export const USER_SEARCH_SELECTOR = '#filters-container'
export const LISTINGS_SELECTOR = '#listings'